import { render, staticRenderFns } from "./dr-formio-in-editor-mode-wrapper.vue?vue&type=template&id=0fc59923&"
import script from "./dr-formio-in-editor-mode-wrapper.vue?vue&type=script&lang=js&"
export * from "./dr-formio-in-editor-mode-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports